import React from "react"

import './../css/home.css';
import {navigate} from 'gatsby'; //import navigate from gatsby


import Layout from "./../components/layout"

import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default function Home() {
    const data = useStaticQuery(graphql`
        query {
        file(relativePath: { eq: "images/home/drama_pic_2.png" }) {
            childImageSharp {
                # Specify a fixed image and fragment.
                # The default width is 400 pixels
                fixed {
                    ...GatsbyImageSharpFixed
                }
            }
        }
        }
    `)
    const portfolioPage = (index)=> {
        navigate('/portfolio'); //navigate to edit page
    }
    return (
    <Layout isPortfolio={false}>

        <div id="home-body">
            <div id="left-text-container">
                <div id="headline-container">
                    <h1>
                        Hi, I'm Pebo Hamza
                    </h1>
                    <div id="rect-divider"/>
                </div>
                <p>
                    I've spent the last 5 years building backend systems at <span style={{fontWeight:'bold'}}>Safello</span>, Sweden's largest crypto exchange.
                    <br/><br/>
                    Started out full-stack — CS from <span style={{fontWeight:'bold'}}>KTH</span>, frontend from <span style={{fontWeight:'bold'}}>Hyper Island</span> — but the backend work took over and that's where I've stayed. Mostly compliance systems, exchange operations and crypto payment flows.
                </p>
                <div id="skill-container">
                    <p>Backend <span className="primary-color">/</span> Crypto <span className="primary-color">/</span> Compliance</p>
                </div>
                <button className="cta-button" onClick={()=>portfolioPage()}>Portfolio</button>
            </div>
            <div id="right-content-container">
                <Img
                    fixed={data.file.childImageSharp.fixed}
                    alt="Pebo posing in suite. Looking professional."
                />
            </div>
        </div>

    </Layout>

    );
}
